import React from "react";

import Popover from "@mui/material/Popover";

import FilterButton from "../FilterButton";

interface BaseFilterProps {
  id: string;
  label: string;
  children: React.ReactNode;
  anchorEl: HTMLButtonElement | null;
  onClose: () => void;
  openPopover: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const BaseFilter: React.FC<BaseFilterProps> = (props) => {
  const { id, label, anchorEl, openPopover, onClose, children } = props;

  const open = Boolean(anchorEl);
  const filterId = open ? `${id}-popover` : undefined;

  return (
    <>
      <FilterButton
        id={id}
        label={label}
        active={open}
        popover
        handleClick={openPopover}
      />
      <Popover
        data-testid={`filter-modal-${id}`}
        id={filterId}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        slotProps={{ paper: { sx: { p: "0 !important" } } }}
      >
        {children}
      </Popover>
    </>
  );
};

export default BaseFilter;
